export const Toast = ({ show, message }) => (
  <div style={{
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    padding: '20px 30px',
    background: 'linear-gradient(135deg, #00ff88, #00f5ff)',
    color: '#000',
    borderRadius: '15px',
    fontFamily: "'Orbitron', monospace",
    fontWeight: '700',
    transform: show ? 'translateX(0)' : 'translateX(150%)',
    transition: 'transform 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    zIndex: 10000,
    boxShadow: '0 10px 40px rgba(0, 255, 136, 0.3)'
  }}>
    {message}
  </div>
);